import React from 'react';

import ContentSectionController from 'Site/Controllers/ContentSectionController';

class PageController extends React.Component {
  constructor (props) {
    super(props);
  }

  renderSection (section, idx) {
    const { type, props, fullWidth } = section;
    const Wrapper = fullWidth || type.toLowerCase() === 'hero' ? 'stack' : 'stack-grid';
    return (
      <Wrapper key={idx}>
        <ContentSectionController type={type} props={props} />
      </Wrapper>
    );
  }

  render () {
    const { content, className, name } = this.props;
    const section = content.map(this.renderSection);
    const fullClassName = 'Page '
      + (name ? name + 'Page ' : '')
      + (className ? className : '');
    return <div className={fullClassName} children={section} />
  }
};

export default PageController;



// WEBPACK FOOTER //
// ./client/Site/Controllers/PageController.jsx